<template>
    <div class="wfmedList">
        <wfList :collapseItem="collapseItem" :url="url" :derUrl="derUrl"></wfList>
    </div>
</template>
<script>
import wfList from "../../components/wflist";
export default {
    data() {
        return {
            collapseItem: [
                { title: "出版年份", name: "00" },
                { title: "中图分类", name: "CLCShort" },
                { title: "中文期刊-刊名", name: "Source_F" }
            ],
            url: "wfmed",
            derUrl: [
                { title: "出版时间", name: "Date desc" },
                { title: "相关度", name: "" },
                { title: "被引次数", name: "CitedCount desc" }
            ]
        };
    },
    components: {
        wfList
    },
    mounted() {
        this.$store.dispatch("actionsHead", { type: true, title: "万方医学网", iconType: true });
    },
    beforeRouteLeave(to, from, next) {
        // 进入C时B正常缓存 当进入的不是C时 this.$destroy()销毁后
        if (to.name === "wfmedDetails") {
            if (!from.meta.isKeepAlive) {
                from.meta.isKeepAlive = true; // 当我们进入到C时开启B的缓存
            }
            sessionStorage.setItem("copyType", 0);
            next();
        } else {
            from.meta.isKeepAlive = false;
            this.$vnode.parent.componentInstance.cache = {};
            this.$vnode.parent.componentInstance.keys = [];
            next(); // 当我们前进的不是C时我们让B页面刷新
        }
    }
};
</script>
<style lang="less">
.van-cell.active {
    span {
        color: red;
    }
}
.van-collapse-item__content {
    padding: 0 16px !important;
    background: #f7f7f7;
    .van-cell {
        background: #f7f7f7;
    }
}
.van-popup {
    > .van-cell {
        font-size: 0.8rem;
        padding-top: 0.8rem;
        padding-bottom: 0.8rem;
        border-bottom: 1px solid #e4e4e4;
    }
}
.wfmedList {
    margin-top: 0.8rem;
    .van-row {
        border-bottom: 1px solid #e3e3e3;
        height: 2.5rem;
        padding: 0.7rem 0;
        background: #fff;
        .van-col--12 {
            color: #487443;
            text-align: center;
        }
    }
    > p {
        font-size: 0.7rem;
        padding: 0.8rem 1rem;
        color: #b0b0b0;
        background: #fff;
    }
    .listCon {
        background: #fff;
        > p {
            padding: 1rem 1rem 0 1rem;
            color: #9a9a9a;
        }
        .van-list {
            .con {
                border-bottom: 1px solid #e3e3e3;
                padding: 1rem;
                h4 {
                    a {
                        color: #486145;
                    }
                    font-weight: 700;
                }
                div {
                    margin-top: 0.5rem;
                    p {
                        margin-bottom: 0.5rem;
                    }
                }
            }
        }
    }
}
</style>
